<template>
  <div>
    <div v-if="loading" style="padding:20px">
      <div class="ui active centered inline large loader"></div>
    </div>
    <div v-else class="ui grid" style="padding:20px">
      <div class="row">
        <div class="six wide column">
          <div class="ui header">Configuration</div>
        </div>
      </div>
      <div class="row">
        <div class="sixteen wide column">
          <div class="ui form">
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="skipPackageDimensionChangeIfNoFeeChange" id="checkbox334456">
                <label for="checkbox334456">Dimension changes: Only alert if FBA fee changed as well</label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="alertForParentChanges" id="checkbox334458">
                <label for="checkbox334458">Parent ASIN: Alert if parent ASIN changes</label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="alertForOwnOfferPriceChanges" id="checkbox334459">
                <label for="checkbox334459">Offer price: Alert if your offer price changes</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <button v-bind:class="dirty ? 'ui primary button' : 'ui disabled primary button'" v-on:click="save()">Save</button>
          <button class="ui basic button" @click="close()">Close </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: true,
      skipPackageDimensionChangeIfNoFeeChange: false,
      skipPackageDimensionChangeIfNoFeeChangeOrig: false,
      alertForParentChanges: false,
      alertForParentChangesOrig: false,
      alertForOwnOfferPriceChanges: false,
      alertForOwnOfferPriceChangesOrig: false,
      dirty: false,
    }
  },
  methods: {
    load: function () {
      this.$http.get('/api/sentinel/watchdogtype/settings/productDetailsRecentChange').then((response) => {
        this.loading = false
        this.skipPackageDimensionChangeIfNoFeeChange = response.body.skipPackageDimensionChangeIfNoFeeChange
        this.skipPackageDimensionChangeIfNoFeeChangeOrig = response.body.skipPackageDimensionChangeIfNoFeeChange
        this.alertForParentChanges = response.body.alertForParentChanges
        this.alertForParentChangesOrig = response.body.alertForParentChanges
        this.alertForOwnOfferPriceChanges = response.body.alertForOwnOfferPriceChanges
        this.alertForOwnOfferPriceChangesOrig = response.body.alertForOwnOfferPriceChanges
      }, (response) => {
        this.loading = false
      })
    },
    close: function () {
      this.$parent.showConfiguration = false
    },
    save: function () {
      this.$http.put('/api/sentinel/watchdogtype/settings/productDetailsRecentChange', {
        skipPackageDimensionChangeIfNoFeeChange: this.skipPackageDimensionChangeIfNoFeeChange,
        alertForParentChanges: this.alertForParentChanges,
        alertForOwnOfferPriceChanges: this.alertForOwnOfferPriceChanges,
      }).then((response) => {
        this.skipPackageDimensionChangeIfNoFeeChangeOrig = this.skipPackageDimensionChangeIfNoFeeChange
        this.alertForParentChangesOrig = this.alertForParentChanges
        this.alertForOwnOfferPriceChangesOrig = this.alertForOwnOfferPriceChanges
        this.updateDirty()
      }, (response) => {
        this.loading = false
      })
    },
    updateDirty: function () {
      this.dirty = this.skipPackageDimensionChangeIfNoFeeChange !== this.skipPackageDimensionChangeIfNoFeeChangeOrig || this.alertForParentChanges !== this.alertForParentChangesOrig || this.alertForOwnOfferPriceChanges !== this.alertForOwnOfferPriceChangesOrig
    }
  },
  created: function () {
    this.load()
  },
  watch: {
    skipPackageDimensionChangeIfNoFeeChange: function () {
      this.updateDirty()
    },
    alertForParentChanges: function () {
      this.updateDirty()
    },
    alertForOwnOfferPriceChanges: function () {
      this.updateDirty()
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ProductDetailsRecentChangeConfig.vue?3a53254c